export default "__VITE_ASSET__DY9j1$hg__"